/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DisplayListingLocationAvailability,
  DisplayPatientTreatmentBeforeAfterPairResponse,
  GetListingPackagesParams,
  GetListingParams,
  ListingMediaModel,
  ListingModel,
  PackageListingExpectationModel,
  PackageModel
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Returns a catalog listing for the current platform
 */
export const getListings = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<ListingModel[]>(
      {url: `/api/v1/listings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetListingsQueryKey = () => {
    return [
    `/api/v1/listings`
    ] as const;
    }

    
export const getGetListingsQueryOptions = <TData = Awaited<ReturnType<typeof getListings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListings>>> = ({ signal }) => getListings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getListings>>>
export type GetListingsQueryError = ErrorType<unknown>


/**
 * @summary Returns a catalog listing for the current platform
 */

export function useGetListings<TData = Awaited<ReturnType<typeof getListings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Generates basic recommended listings for the current user
 */
export const generateBasicRecommendedListings = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<ListingModel[]>(
      {url: `/api/v1/listings/basic-recommended`, method: 'POST', signal
    },
      options);
    }
  


export const getGenerateBasicRecommendedListingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateBasicRecommendedListings>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof generateBasicRecommendedListings>>, TError,void, TContext> => {

const mutationKey = ['generateBasicRecommendedListings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateBasicRecommendedListings>>, void> = () => {
          

          return  generateBasicRecommendedListings(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateBasicRecommendedListingsMutationResult = NonNullable<Awaited<ReturnType<typeof generateBasicRecommendedListings>>>
    
    export type GenerateBasicRecommendedListingsMutationError = ErrorType<unknown>

    /**
 * @summary Generates basic recommended listings for the current user
 */
export const useGenerateBasicRecommendedListings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateBasicRecommendedListings>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateBasicRecommendedListings>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGenerateBasicRecommendedListingsMutationOptions(options));
    }
    /**
 * @summary Returns a catalog listing for the current platform
 */
export const getPublicListings = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<ListingModel[]>(
      {url: `/api/v1/listings/public`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicListingsQueryKey = () => {
    return [
    `/api/v1/listings/public`
    ] as const;
    }

    
export const getGetPublicListingsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicListings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicListingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicListings>>> = ({ signal }) => getPublicListings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicListings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicListings>>>
export type GetPublicListingsQueryError = ErrorType<unknown>


/**
 * @summary Returns a catalog listing for the current platform
 */

export function useGetPublicListings<TData = Awaited<ReturnType<typeof getPublicListings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicListingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns a catalog listing for the current platform
 */
export const getListing = (
    id: string,
    params?: GetListingParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<ListingModel>(
      {url: `/api/v1/listings/${id}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetListingQueryKey = (id: string,
    params?: GetListingParams,) => {
    return [
    `/api/v1/listings/${id}`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetListingQueryOptions = <TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<unknown>>(id: string,
    params?: GetListingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListing>>> = ({ signal }) => getListing(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingQueryResult = NonNullable<Awaited<ReturnType<typeof getListing>>>
export type GetListingQueryError = ErrorType<unknown>


/**
 * @summary Returns a catalog listing for the current platform
 */

export function useGetListing<TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetListingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * The catalog reads scope a listing to the patient's own location, so a shared link to an
item sold elsewhere resolves to a bare not-found. This says where it is sold, so the app
can offer to switch location instead of dead-ending.
 * @summary Returns the locations a listing is purchasable at.
 */
export const getListingLocationAvailability = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayListingLocationAvailability>(
      {url: `/api/v1/listings/${id}/location-availability`, method: 'GET', signal
    },
      options);
    }
  



export const getGetListingLocationAvailabilityQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/location-availability`
    ] as const;
    }

    
export const getGetListingLocationAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getListingLocationAvailability>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingLocationAvailability>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingLocationAvailabilityQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingLocationAvailability>>> = ({ signal }) => getListingLocationAvailability(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingLocationAvailability>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingLocationAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getListingLocationAvailability>>>
export type GetListingLocationAvailabilityQueryError = ErrorType<void>


/**
 * @summary Returns the locations a listing is purchasable at.
 */

export function useGetListingLocationAvailability<TData = Awaited<ReturnType<typeof getListingLocationAvailability>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingLocationAvailability>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingLocationAvailabilityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns the collection of packages tied to a particular listing
 */
export const getListingPackages = (
    id: string,
    params?: GetListingPackagesParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<PackageModel[]>(
      {url: `/api/v1/listings/${id}/packages`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetListingPackagesQueryKey = (id: string,
    params?: GetListingPackagesParams,) => {
    return [
    `/api/v1/listings/${id}/packages`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetListingPackagesQueryOptions = <TData = Awaited<ReturnType<typeof getListingPackages>>, TError = ErrorType<unknown>>(id: string,
    params?: GetListingPackagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingPackages>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingPackagesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingPackages>>> = ({ signal }) => getListingPackages(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingPackages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof getListingPackages>>>
export type GetListingPackagesQueryError = ErrorType<unknown>


/**
 * @summary Returns the collection of packages tied to a particular listing
 */

export function useGetListingPackages<TData = Awaited<ReturnType<typeof getListingPackages>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetListingPackagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingPackages>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingPackagesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns the treatment expectations tied to a particular listing
 */
export const getListingExpectations = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<PackageListingExpectationModel[]>(
      {url: `/api/v1/listings/${id}/expectations`, method: 'GET', signal
    },
      options);
    }
  



export const getGetListingExpectationsQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/expectations`
    ] as const;
    }

    
export const getGetListingExpectationsQueryOptions = <TData = Awaited<ReturnType<typeof getListingExpectations>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingExpectations>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingExpectationsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingExpectations>>> = ({ signal }) => getListingExpectations(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingExpectations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingExpectationsQueryResult = NonNullable<Awaited<ReturnType<typeof getListingExpectations>>>
export type GetListingExpectationsQueryError = ErrorType<unknown>


/**
 * @summary Returns the treatment expectations tied to a particular listing
 */

export function useGetListingExpectations<TData = Awaited<ReturnType<typeof getListingExpectations>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingExpectations>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingExpectationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns a collection of the media items attached to a listing
 */
export const getListingMedia = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<ListingMediaModel[]>(
      {url: `/api/v1/listings/${id}/media`, method: 'GET', signal
    },
      options);
    }
  



export const getGetListingMediaQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/media`
    ] as const;
    }

    
export const getGetListingMediaQueryOptions = <TData = Awaited<ReturnType<typeof getListingMedia>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingMedia>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingMediaQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingMedia>>> = ({ signal }) => getListingMedia(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getListingMedia>>>
export type GetListingMediaQueryError = ErrorType<unknown>


/**
 * @summary Returns a collection of the media items attached to a listing
 */

export function useGetListingMedia<TData = Awaited<ReturnType<typeof getListingMedia>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingMedia>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingMediaQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns a collection of listings that are related to this one
 */
export const getRelatedListings = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<ListingModel[]>(
      {url: `/api/v1/listings/${id}/related`, method: 'GET', signal
    },
      options);
    }
  



export const getGetRelatedListingsQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/related`
    ] as const;
    }

    
export const getGetRelatedListingsQueryOptions = <TData = Awaited<ReturnType<typeof getRelatedListings>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRelatedListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRelatedListingsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRelatedListings>>> = ({ signal }) => getRelatedListings(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRelatedListings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRelatedListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getRelatedListings>>>
export type GetRelatedListingsQueryError = ErrorType<unknown>


/**
 * @summary Returns a collection of listings that are related to this one
 */

export function useGetRelatedListings<TData = Awaited<ReturnType<typeof getRelatedListings>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRelatedListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRelatedListingsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns the practice-uploaded before/after photo pairs for a listing, ordered so the pairs
most like the requesting patient come first.
 */
export const getListingBeforeAfters = (
    id: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayPatientTreatmentBeforeAfterPairResponse[]>(
      {url: `/api/v1/listings/${id}/before-afters`, method: 'GET', signal
    },
      options);
    }
  



export const getGetListingBeforeAftersQueryKey = (id: string,) => {
    return [
    `/api/v1/listings/${id}/before-afters`
    ] as const;
    }

    
export const getGetListingBeforeAftersQueryOptions = <TData = Awaited<ReturnType<typeof getListingBeforeAfters>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingBeforeAfters>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingBeforeAftersQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListingBeforeAfters>>> = ({ signal }) => getListingBeforeAfters(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListingBeforeAfters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingBeforeAftersQueryResult = NonNullable<Awaited<ReturnType<typeof getListingBeforeAfters>>>
export type GetListingBeforeAftersQueryError = ErrorType<unknown>


/**
 * @summary Returns the practice-uploaded before/after photo pairs for a listing, ordered so the pairs
most like the requesting patient come first.
 */

export function useGetListingBeforeAfters<TData = Awaited<ReturnType<typeof getListingBeforeAfters>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListingBeforeAfters>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingBeforeAftersQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns no content because the quarterly RepeatMD giveaway has been retired.
 */
export const getRepeatMDOffer = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/offers`, method: 'GET', signal
    },
      options);
    }
  



export const getGetRepeatMDOfferQueryKey = () => {
    return [
    `/api/v1/offers`
    ] as const;
    }

    
export const getGetRepeatMDOfferQueryOptions = <TData = Awaited<ReturnType<typeof getRepeatMDOffer>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepeatMDOffer>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRepeatMDOfferQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepeatMDOffer>>> = ({ signal }) => getRepeatMDOffer(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRepeatMDOffer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRepeatMDOfferQueryResult = NonNullable<Awaited<ReturnType<typeof getRepeatMDOffer>>>
export type GetRepeatMDOfferQueryError = ErrorType<void>


/**
 * @summary Returns no content because the quarterly RepeatMD giveaway has been retired.
 */

export function useGetRepeatMDOffer<TData = Awaited<ReturnType<typeof getRepeatMDOffer>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRepeatMDOffer>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRepeatMDOfferQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




